var map = {
	"./BG-DarkBlue-0000.png": 1181,
	"./BG-DarkBlue-0001.png": 1182,
	"./BG-DarkBlue-0002.png": 1183,
	"./BG-DarkBlue-0003.png": 1184,
	"./BG-DarkBlue-0004.png": 1185,
	"./BG-DarkBlue-0005.png": 1186,
	"./BG-DarkBlue-0006.png": 1187,
	"./BG-DarkBlue-0007.png": 1188,
	"./BG-Green-0000.png": 1189,
	"./BG-Green-0001.png": 1190,
	"./BG-Green-0002.png": 1191,
	"./BG-Green-0003.png": 1192,
	"./BG-Green-0004.png": 1193,
	"./BG-Green-0005.png": 1194,
	"./BG-Green-0006.png": 1195,
	"./BG-Green-0007.png": 1196,
	"./BG-LightBlue-0000.png": 1197,
	"./BG-LightBlue-0001.png": 1198,
	"./BG-LightBlue-0002.png": 1199,
	"./BG-LightBlue-0003.png": 1200,
	"./BG-LightBlue-0004.png": 1201,
	"./BG-LightBlue-0005.png": 1202,
	"./BG-LightBlue-0006.png": 1203,
	"./BG-LightBlue-0007.png": 1204,
	"./BG-Red-0000.png": 1205,
	"./BG-Red-0001.png": 1206,
	"./BG-Red-0002.png": 1207,
	"./BG-Red-0003.png": 1208,
	"./BG-Red-0004.png": 1209,
	"./BG-Red-0005.png": 1210,
	"./BG-Red-0006.png": 1211,
	"./BG-Red-0007.png": 1212,
	"./BG-Yellow-0000.png": 1213,
	"./BG-Yellow-0001.png": 1214,
	"./BG-Yellow-0002.png": 1215,
	"./BG-Yellow-0003.png": 1216,
	"./BG-Yellow-0004.png": 1217,
	"./BG-Yellow-0005.png": 1218,
	"./BG-Yellow-0006.png": 1219,
	"./BG-Yellow-0007.png": 1220,
	"./SG-DarkBlue-0000.png": 1221,
	"./SG-DarkBlue-0001.png": 1222,
	"./SG-DarkBlue-0002.png": 1223,
	"./SG-DarkBlue-0003.png": 1224,
	"./SG-DarkBlue-0004.png": 1225,
	"./SG-DarkBlue-0005.png": 1226,
	"./SG-DarkBlue-0006.png": 1227,
	"./SG-DarkBlue-0007.png": 1228,
	"./SG-Green-0000.png": 1229,
	"./SG-Green-0001.png": 1230,
	"./SG-Green-0002.png": 1231,
	"./SG-Green-0003.png": 1232,
	"./SG-Green-0004.png": 1233,
	"./SG-Green-0005.png": 1234,
	"./SG-Green-0006.png": 1235,
	"./SG-Green-0007.png": 1236,
	"./SG-LightBlue-0000.png": 1237,
	"./SG-LightBlue-0001.png": 1238,
	"./SG-LightBlue-0002.png": 1239,
	"./SG-LightBlue-0003.png": 1240,
	"./SG-LightBlue-0004.png": 1241,
	"./SG-LightBlue-0005.png": 1242,
	"./SG-LightBlue-0006.png": 1243,
	"./SG-LightBlue-0007.png": 1244,
	"./SG-Red-0000.png": 1245,
	"./SG-Red-0001.png": 1246,
	"./SG-Red-0002.png": 1247,
	"./SG-Red-0003.png": 1248,
	"./SG-Red-0004.png": 1249,
	"./SG-Red-0005.png": 1250,
	"./SG-Red-0006.png": 1251,
	"./SG-Red-0007.png": 1252,
	"./SG-White-0000.png": 1253,
	"./SG-White-0001.png": 1254,
	"./SG-White-0002.png": 1255,
	"./SG-White-0003.png": 1256,
	"./SG-White-0004.png": 1257,
	"./SG-White-0005.png": 1258,
	"./SG-White-0006.png": 1259,
	"./SG-White-0007.png": 1260,
	"./SG-Yellow-0000.png": 1261,
	"./SG-Yellow-0001.png": 1262,
	"./SG-Yellow-0002.png": 1263,
	"./SG-Yellow-0003.png": 1264,
	"./SG-Yellow-0004.png": 1265,
	"./SG-Yellow-0005.png": 1266,
	"./SG-Yellow-0006.png": 1267,
	"./SG-Yellow-0007.png": 1268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1180;